export class DadosSeparacao {
  idCupom: string;
  peso: number;
  volume: number;
}
